/**
 * @author Fernando Ruano
 * @file actions.js
 * @description App Store Actions
 */

// Constants
import {
  SET_LOADING,
  SET_USER,
  SET_RESPONSE,
  SET_TITLE,
  SET_PATIENT_INDICATORS,
  SET_PATIENT_EVENT_TYPE,
  SET_CLINIC_ID,
  SET_LAST_VERSIA_UPDATE,
  SET_CLINICS,
  SET_INSURERS,
  SET_TABLE_DATA
} from './constants';

/**
 * Show/hide loading general to all app
 * @param  { bool } loading - Indicate if show/hide loading
 * @return { object } An action object with a type of SET_LOADING
 */
export const setLoading = (loading) => ({
  type: SET_LOADING,
  payload: { loading }
});

/**
 * Set response state
 * @param  { String } type - Response type
 * @param  { String } title - Response title to display
 * @param  { String } message - Response message to display
 * @param  { String } response - Response data
 * @param  { callback } message - Callback to send response
 * @return { object } An action object with a type of SET_RESPONSE
 */
export const setResponse = (type, title, message, response, callback) => {
  if (callback) {
    callback(type, response, { type, title, message });
  }
  return { type: SET_RESPONSE, payload: { type, title, message } };
};

/**
 * Set response state
 * @param  { String } main - Title
 * @param  { String } sub - Subtitle
 * @return { object } An action object with a type of SET_RESPONSE
 */
export const setTitle = (main, sub) => ({
  type: SET_TITLE,
  payload: { main, sub }
});

/**
 * Set user state
 * @param  { object } user - User data
 * @return { object } An action object with a type of SET_USER
 */
export const setUser = (user) => ({ type: SET_USER, payload: { user } });

/**
 * Set patient indicator state
 * @param  { Array } patientIndicators - patient indicators array
 * @return { Array } An action object with a type of SET_PATIENT_INDICATORS
 */
export const setPatientIndicators = (patientIndicators) => ({
  type: SET_PATIENT_INDICATORS,
  payload: { patientIndicators }
});

/**
 * Set patient indicator state
 * @param  { Array } patientEventType - patient event type array
 * @return { Array } An action object with a type of SET_PATIENT_EVENT_TYPES
 */
export const setPatientEventType = (patientEventType) => ({
  type: SET_PATIENT_EVENT_TYPE,
  payload: { patientEventType }
});

/**
 * Set clinic id state
 * @param  { number } clinicId - clinicId
 * @return { Array } An action object with a type of SET_CLINIC_ID
 */
export const setClinicId = (clinicId) => ({
  type: SET_CLINIC_ID,
  payload: { clinicId }
});

/**
 * Set last versia update
 * @param  { string } - versia update date
 * @return { string } latest versia date
 */
export const setLastVersiaUpdate = (lastVersiaUpdate) => {
  return {
    type: SET_LAST_VERSIA_UPDATE,
    payload: { lastVersiaUpdate }
  };
};

/**
 * Set last versia update
 * @param  { string } - versia update date
 * @return { Array } An action object with a type of clinic
 */
export const setClinics = (clinics) => {
  return {
    type: SET_CLINICS,
    payload: { clinics }
  };
};

/**
 * Set last versia update
 * @param  { string } - versia update date
 * @return { Array } An action object with a type of clinic
 */
export const setInsurers = (insurers) => {
  return {
    type: SET_INSURERS,
    payload: { insurers }
  };
};

/**
 * Show/hide loading general to all app
 * @param  { bool } loading - Indicate if show/hide loading
 * @return { object } An action object with a type of SET_LOADING
 */
export const setTableConfig = (body) => ({
  type: SET_TABLE_DATA,
  payload: { tableConfig: body }
});
